import ToyotaAdBanner from "app/ad-banner/ToyotaAdBanner";
import gameTitleImage from "app/assets/spellcheck.png";
import useGameData from "app/game-data/useGameData";
import { GameAction } from "app/game/gameState";
import { useGameActionDispatch, useGameState } from "app/game/useGame";
import ExitGameButton from "app/top-nav/ExitGameButton";
import MenuButton from "app/ui/MenuButton";
import TypoWord from "app/ui/TypoWord";
import cn from "app/utils/classnames";
import formatPublishDate from "app/utils/formatPublishDate";
import mixpanel from "mixpanel-browser";
import { useKey } from "react-use";

export default function TitleScreen() {
  const { id: gameId } = useGameState();
  const dispatch = useGameActionDispatch();

  const data = useGameData();
  const publishDate = data?.publishDate ?? "07-28-1988";
  const constructorName =
    data?.levels[0]?.constructorName ?? "Word Spellingman";

  function handleEnterPressed() {
    mixpanel.track("game_start", { game_id: gameId });
    dispatch({ type: GameAction.TITLE_SCREEN_EXITED });
  }
  useKey("Enter", handleEnterPressed);

  return (
    <div className="h-full w-full max-h-full flex flex-col relative">
      <div className="w-full flex">
        <ExitGameButton alwaysShowText textColor="text-text" />
      </div>
      <ToyotaAdBanner />
      <div
        className={cn(
          "max-w-3xl mx-auto flex-2",
          "flex flex-col items-center justify-center gap-4 lg:gap-6 px-2 py-1",
        )}
      >
        <img
          src={gameTitleImage}
          className="flex border border-black rounded-md p-4"
          alt=""
          width={250}
          height={250}
          onLoad={() => {
            mixpanel.track_pageview({
              page: `Game Title Screen`,
              game_id: gameId,
            });
            mixpanel.track_pageview({
              page: `Spellcheck: Landing Page`,
              game_id: gameId,
            });
          }}
        />

        <h1
          className={cn(
            "text-center text-[2rem] font-bold leading-none -tracking-[0.02em]",
            "border border-black rounded-md",
            "px-12 py-3",
          )}
        >
          Spellcheck
        </h1>

        <p
          className={cn(
            "max-w-md px-2",
            "text-center text-lg font-bold uppercase leading-[1.38] tracking-[0.03em]",
          )}
        >
          <TypoWord word="Expand" /> <TypoWord word="your" />{" "}
          <TypoWord word="vocabulary" /> and spell <TypoWord word="words" />{" "}
          that <TypoWord word="refresh" /> <TypoWord word="daily" />.
        </p>

        {publishDate && (
          <div className="flex flex-col items-center gap-3 lg:gap-4">
            <MenuButton
              className={cn(
                "px-8 max-w-30",
                "text-lg font-mono uppercase",
                "flex justify-center",
              )}
              onClick={() => {
                mixpanel.track("game_start", { game_id: gameId });
                dispatch({ type: GameAction.TITLE_SCREEN_EXITED });
              }}
            >
              <TypoWord word="Play" /> Now
            </MenuButton>
            <p className="text-center text-sm tracking-[-0.015em] lg:text-base">
              {`By ${constructorName} - ${formatPublishDate(publishDate)}`}
            </p>
          </div>
        )}
      </div>
      <div className="w-full flex justify-center mb-2">
        <p className="text-sm text-center">
          Based on a concept by{" "}
          <a
            href="https://www.youtube.com/watch?v=KK3mS4bQ5JM"
            className="underline font-semibold"
            target="_blank"
            rel="noopener noreferrer"
          >
            Answer in Progress
          </a>
          .
        </p>
      </div>
    </div>
  );
}
